export default "__VITE_ASSET__CAMsJq$8__"